/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';
import { FormsModule } from '@angular/forms';
import { DatePicker } from 'primeng/datepicker';

@Component({
  selector: 'well-date-table-filter',
  templateUrl: './date-table-filter.component.html',
  styleUrls: ['./date-table-filter.component.scss'],
  imports: [DatePicker, FormsModule, DatePicker],
  standalone: true,
})
export class DateTableFilterComponent {
  @Input() placeholder?: string;
  @Input() format?: string;
  @Input() value: any | undefined = undefined;
  @Input() name?: string;
  @Input() style: any | undefined = undefined;
  @Input() showClear = false;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onFilter: EventEmitter<any> = new EventEmitter<any>();

  get displayValue(): string | null {
    if (!this.value) return null;
    if (typeof this.value === 'string') {
      return this.value.substring(0, 10);
    }
    if (this.value instanceof Date) {
      return moment(this.value).format('YYYY-MM-DD');
    }
    return this.value;
  }

  getDateString(event: any) {
    if (this.format) {
      return moment(event).format(this.format);
    }

    return event;
  }
}
